import { useCallback, useState } from 'react';

export const DEFAULT_PANEL_WIDTH = 360;
export const MIN_PANEL_WIDTH = 280;
export const MAX_PANEL_WIDTH = 600;

const clamp = (n: number) => Math.min(MAX_PANEL_WIDTH, Math.max(MIN_PANEL_WIDTH, n));

function readStored(storageKey: string, fallback: number): number {
  try {
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? Number(raw) : NaN;
    return Number.isFinite(parsed) ? clamp(parsed) : clamp(fallback);
  } catch {
    return clamp(fallback);
  }
}

export function usePanelWidth(storageKey: string, defaultWidth = DEFAULT_PANEL_WIDTH) {
  const [width, setWidthState] = useState<number>(() => readStored(storageKey, defaultWidth));

  const setWidth = useCallback((next: number) => {
    setWidthState(clamp(next));
  }, []);

  const commitWidth = useCallback(
    (next: number) => {
      const clamped = clamp(next);
      setWidthState(clamped);
      try {
        localStorage.setItem(storageKey, String(clamped));
      } catch {
        /* storage blocked, or the quota is full — a lost width is not worth an error */
      }
    },
    [storageKey],
  );

  return { width, setWidth, commitWidth };
}
